export const formatHours = (hours: number | undefined | null): string => {
  return `${(hours || 0).toFixed(2)}h`
}
